var map = {
	"./discord.svg": 338,
	"./email.svg": 426,
	"./facebook.svg": 957,
	"./github.svg": 443,
	"./instagram.svg": 574,
	"./mobile-qr.svg": 932,
	"./profile.jpg": 277,
	"./qr-code.svg": 451,
	"./stackoverflow.svg": 160,
	"./telegram.svg": 39,
	"./twitter.svg": 663,
	"./whatsapp.svg": 144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;